<template>
    <div>
        <a-skeleton :loading="loading" active>
            <a-list item-layout="horizontal" size="small" :data-source="data">
                <a-list-item slot="renderItem" slot-scope="item">
                    <a-list-item-meta>
                        <a slot="title" :href="`/list/?id=${ item.id }`" target="_blank">{{ item.title }}</a>
                    </a-list-item-meta>
                </a-list-item>
            </a-list>
            <!-- <a-pagination :current="Number($route.params.page)" :total="tower" 
                :defaultPageSize="20" @change="change" :hideOnSinglePage="true"
            /> -->
        </a-skeleton>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    data: () => ({
        data: [],
        loading: false,
    }),
    created() {
        this.load();
    },
    methods: {
        async load() {
            this.loading = true;
            const { data } = await axios.get("/backend/user/list.php");
            this.data = data.lists;
            this.loading = false;
        }
    }
}
</script>

<style>

</style>